/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import { IMenuItem } from "../../models";
import styles from "./menu.module.scss";

const isMenuItemSelected = (menuItem: IMenuItem, pathname: string): boolean => {
	if (menuItem.route && pathname === menuItem.route) {
		return true;
	}

	return (
		menuItem.children?.some((child) => isMenuItemSelected(child, pathname)) ??
		false
	);
};

export const MenuItem = React.memo(
	({
		route,
		label,
		iconUrl,
		selectedIconUrl,
		selected,
		onClick,
		children,
		className
	}: IMenuItem) => {
		const { pathname } = useLocation();
		const [isExpanded, setIsExpanded] = React.useState(false);
		const hasChildren = Boolean(children?.length);
		const isSelected =
			selected ??
			isMenuItemSelected(
				{
					route,
					label,
					iconUrl,
					selectedIconUrl,
					selected,
					onClick,
					children,
					className
				},
				pathname
			);

		if (hasChildren) {
			return (
				<div className={styles.menuGroup}>
					<div className="flex">
						<button
							type="button"
							className={`${styles.menuitem} ${styles.menuGroupTrigger}
							${isSelected ? styles.menuitemSelected : ""}`}
							onClick={() => setIsExpanded((currentValue) => !currentValue)}
						>
							<img
								src={isSelected ? selectedIconUrl : iconUrl}
								width="26"
								height="26"
							/>
							<div className="mt-2">{label}</div>
							<img
								src="images/svg/chevron-up-grey.svg"
								width="16"
								height="16"
								className={`${styles.menuChevron}
								${!isExpanded ? styles.menuChevronCollapsed : ""}`}
							/>
						</button>
					</div>
					{isExpanded ? (
						<div className={styles.menuGroupChildren}>
							{children?.map((child) => (
								<MenuItem
									key={child.route ?? child.label}
									{...child}
									className={styles.menuitemChild}
								/>
							))}
						</div>
					) : null}
				</div>
			);
		}

		const link = (
			<div
				className={`flex justify-start ${styles.menuitem}
        ${isSelected ? styles.menuitemSelected : ""}
				${className ?? ""}`}
				onClick={onClick}
			>
				<img
					src={isSelected ? selectedIconUrl : iconUrl}
					width="20px"
					height="20px"
				/>
				<div className="mt-1">{label}</div>
			</div>
		);

		return route ? <Link to={route}>{link}</Link> : link;
	}
);
